import { Tooltip, type TooltipProps } from "@opensea/ui-kit"
import { useTranslations } from "use-intl"

export function MaxSlippageTooltip({
  children,
}: {
  children: TooltipProps["children"]
}) {
  const t = useTranslations("wallet.MaxSlippageTooltip")
  return (
    <Tooltip content={<div className="max-w-[250px]">{t("description")}</div>}>
      {children}
    </Tooltip>
  )
}
